<template>
  <div class="page" ref="page" :style="pageStyle">
    <div class="page-container">
      <PageImage :data-loaded="loaded" @loaded="imageLoaded" class="page-image" :page="page" :height="calcHeight" :width="calcWidth" />
      <PageDraw class="page-draw" v-if="loaded && $store.getters.drawMode !== 'hide'" :page="page" :height="calcHeight" :width="calcWidth" />
      <transition name="fade">
        <div class="page-content" v-if="loaded">
          <template v-for="(pageEl, index) in pageElements">
            <PageElement :element="pageEl" :key="index" />
          </template>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import PageImage from './PageImage'
import PageDraw from './PageDraw'
import PageElement from './PageElement'

export default {
  data () {
    return {
      pageElm: null,
      imageHeight: null,
      imageWidth: null,
      loaded: false
    }
  },
  mounted () {
    this.pageElm = this.$el
  },
  methods: {
    imageLoaded (image) {
      this.imageHeight = image.naturalHeight * this.zoomLevel
      this.imageWidth = image.naturalWidth * this.zoomLevel
      this.loaded = true
      this.$emit('loaded')
    }
  },
  computed: {
    ratio () {
      return this.maxHeight / this.maxWidth
    },
    calcHeight () {
      if (!(this.imageHeight / this.imageWidth > this.ratio) && this.imageWidth > this.maxWidth) {
        return Math.round(this.imageHeight * (this.maxWidth / this.imageWidth))
      } else {
        return this.maxHeight
      }
    },
    calcWidth () {
      if ((this.imageHeight / this.imageWidth > this.ratio)) {
        return Math.round(this.imageWidth * (this.maxHeight / this.imageHeight))
      } else {
        return this.maxWidth
      }
    },
    pageStyle () {
      return {
        'width': `${this.calcWidth}px`,
        'height': `${this.calcHeight}px`
      }
    },
    pageElements () {
      var els = []
      if (this.page != null && this.page.pageElements != null) {
        return this.page.pageElements.map(el => {
          return {
            ...el,
            x: Math.ceil(el.x * this.calcWidth),
            y: Math.ceil(el.y * this.calcHeight),
            attachment: this.page.attachments.find(a => a.id === el.itemId)
          }
        })
      }

      return els
    },
    zoomLevel () {
      return this.$store.getters.zoom ? 2 : 1
    }
  },
  props: {
    page: {
      type: Object
    },
    maxHeight: {
      type: Number
    },
    maxWidth: {
      type: Number
    }
  },
  watch: {
    page (newVal, oldVal) {
      this.loaded = false
    },
    '$store.getters.zoom' (newVal) {
      if (newVal) {
        this.imageHeight = this.imageHeight * 2
        this.imageWidth = this.imageWidth * 2
      } else {
        this.imageHeight = this.imageHeight / 2
        this.imageWidth = this.imageWidth / 2
      }
    }
  },
  components: {
    PageImage,
    PageElement,
    PageDraw
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/page/Page.vue